import * as Lockr from 'lockr';

export const StorageService = {
    getLocal,
    setLocal,
    deleteLocal,
    getSession,
    setSession,
    deleteSession,
};

function getLocal<T>(key: string, defaultValue?: T): T {
    return Lockr.get<T>(key, defaultValue);
}

function setLocal(key: string, data: string | number | object): void {
    Lockr.set(key, data);
}

function deleteLocal(key: string) {
    Lockr.rm(key);
}

function setSession(key: string, data: string) {
    sessionStorage.setItem(key, data);
}

function getSession<T = string>(key: string, defaultValue?: T) {
    return sessionStorage.getItem(key) || defaultValue;
}

function deleteSession(key: string) {
    sessionStorage.removeItem(key);
}
